import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PrivateCartIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    title={t`Private Cart`}
    {...props}
    testID="private-cart-icon"
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.595 7.676 15 8.432v.892m-3.405-1.648H5.54v-.757h-.757m6.81.757L10.46 2M4.784 6.919h-2.27m2.27 0V3.892m0-1.892h5.676M4.784 2h-.757m.757 0v1.892M10.46 2h1.135M2.514 6.919H1.378L1 12.216h6M2.514 6.92V3.892h2.27"
      fill="none"
    />
    <Circle
      cx={4.027}
      cy={12.216}
      r={1.514}
      fill="#fff"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <Path
      fill="currentColor"
      d="M9 16V9.5h2.565c.492 0 .912.094 1.26.282.347.187.611.446.793.778.184.33.276.711.276 1.143 0 .431-.093.812-.28 1.142-.186.33-.455.587-.809.771-.35.184-.776.277-1.275.277H9.895V12.79h1.412c.265 0 .483-.045.654-.136a.905.905 0 0 0 .387-.384c.087-.165.13-.355.13-.568 0-.216-.043-.404-.13-.565a.87.87 0 0 0-.387-.378c-.173-.091-.393-.136-.66-.136h-.927V16H9Z"
    />
  </Icon>
);
